<template>
  <div class="calculator__container">
    <CalculatorComponent
      id="calculator"
      v-if="this.chosenCar !== ''"
      :cars="this.cars"
      :chosenCar="this.post"
      :rateToPay="this.rateToPay"
    />
  </div>
</template>

<script>
import CalculatorComponent from "./components/Calculator.vue";
import _ from "lodash";
export default {
  name: "App",
  components: {
    CalculatorComponent,
  },
  data() {
    return {
      post: {
        type: "porsche_leasing_jak_abonament",
        model: "",
        price: "",
        km_limit: "",
        rate: "",
        payment: "",
        initial: 0,
      },
      cars: [],
      chosenCar: "",
      carObj: {
        initial_km_limit: "",
        initial_payment: "",
        initial_price: "",
        initial_rates: "",
        km_limits: [],
        preliminary_payment: [],
        rates: [],
        name: "",
      },
      swiperOptions: {
        breakpoints: {
          300: {
            slidesPerView: 1,
            spaceBetween: 25,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 25,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
        },
      },
      rateToPay: 0,
    };
  },
  created() {
    this.fetchData(this.post.type);
  },
  computed: {
    type() {
      return this.post.type;
    },
    rates() {
      return this.carObj.rates;
    },
  },
  watch: {
    type(newVal) {
      this.fetchData(newVal);
    },
    chosenCar(car) {
      if (car !== "") {
        this.carObj = {
          initial_km_limit: parseInt(this.cars[car]["initial_km_limit"]),
          initial_payment: this.cars[car]["initial_payment"],
          initial_price: this.cars[car]["initial_price"],
          initial_rates: this.cars[car]["initial_rates"],
          km_limits: this.cars[car]["km_limits"],
          preliminary_payment: this.cars[car]["preliminary_payment"]
            ? this.cars[car]["preliminary_payment"]
            : this.cars[car]["own_payments"],
          rates: this.cars[car]["rates"],
          name: this.cars[car]["name"],
        };
        this.post.model = this.cars[car]["name"];
        this.post.price = this.cars[car]["initial_price"];
        this.post.km_limit = this.cars[car]["initial_km_limit"];
        this.post.rate = this.cars[car]["initial_rates"];
        if (this.post.type == "porsche_leasing_jak_abonament") {
          this.post.payments = this.cars[car]["preliminary_payment"];
          if (this.carObj.preliminary_payment[0] == 0) {
            this.carObj.preliminary_payment =
              this.carObj.preliminary_payment.shift();
          }
        } else if (this.post.type == "porsche_kredyt_jak_abonament") {
          this.post.payments = this.cars[car]["own_payments"];
        }
        this.post.payment = this.cars[car]["initial_payment"];
        this.post.km_limits = this.cars[car]["km_limits"];
        this.post.rates = this.cars[car]["rates"];
        this.post.initial = 0;
        this.fetchLoan(this.post);
      }
    },
  },
  methods: {
    changeButton(id) {
      this.post.type = id;
      this.chosenCar = "";
    },
    onChooseChild(val) {
      console.log("onChooseChild", val);
      this.chosenFinancing = val;
      if (this.post.type == "porsche_leasing_jak_abonament") {
        if (this.chosenFinancing == "mrv") {
          this.financingColumn = this.info_1_leasing;
        } else if (this.chosenFinancing == "kre") {
          this.financingColumn = this.info_2_leasing;
        }
      } else if (this.post.type == "porsche_kredyt_jak_abonament") {
        if (this.chosenFinancing == "mrv") {
          this.financingColumn = this.info_1_kredyt;
        } else if (this.chosenFinancing == "kre") {
          this.financingColumn = this.info_2_kredyt;
        }
      }
    },
    fetchLoan: _.debounce(async function (post) {
      const tokenKey = "G6j7mjalSZZic";
      const response = await fetch(
        "https://kalkulator.vwbank.pl/vwapi/calculate/" +
          post.type +
          "/?inital=" +
          post.initial +
          "&token=" +
          tokenKey +
          "&model=" +
          post.model +
          "&price=" +
          post.price +
          "&km_limit=" +
          parseInt(post.km_limit) +
          "&rate=" +
          post.rate +
          "&payment=" +
          post.payment,
        {
          method: "POST",
          mode: "cors",
          // headers: {
          //   Accept: "*/*",
          //   "Content-Type": "application/json",
          //   "User-Agent": "Thunder Client (https://www.thunderclient.com)",
          // },
        }
      );
      const data = await response.json();
      this.rateToPay = data.content.rate;
    }, 300),

    async fetchData(leasing) {
      const tokenKey = "G6j7mjalSZZic";
      const response = await fetch(
        "https://kalkulator.vwbank.pl/vwapi/get_config/" +
          leasing +
          "?token=" +
          tokenKey
      );
      const data = await response.json();
      const arr = [];
      Object.entries(data.content).forEach((el) => {
        if (
          el[0] === "Cayenne" ||
          el[0] === "718 Cayman" ||
          el[0] === "911 Carrera" ||
          el[0] === "Macan" ||
          el[0] === "Panamera" ||
          el[0] === "Taycan"
        ) {
          arr.push(el);
        }
      });
      this.cars = Object.fromEntries(arr);
      this.chooseCar("Cayenne");
    },
    async chooseCar(car) {
      this.chosenCar = car;
      await this.$nextTick();
      const el = document.querySelector(".calculator__calculator");
      el.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    },
    getImgUrl(name) {
      let url;
      let connection;

      connection = "./assets/";

      if (name == "produkt") {
        url = require(connection + name + ".png");
      } else {
        url = require(connection + name + ".jpg");
      }
      return url;
    },
  },
};
</script>

<style lang="scss">
@import "./styles/styles.scss";
</style>
